import { TabBar, TabBarItem } from 'react-native-tab-view';
import { Colors, Flex, Typography, useScreenSize } from '@banhala/ui-kit';
import type {
  SceneRendererProps,
  NavigationState,
} from 'react-native-tab-view';
import type { LikeTabRoute } from '../LikeContents';

type LikeTabBarProps = SceneRendererProps & {
  navigationState: NavigationState<LikeTabRoute>;
  onTabClick?: (index: number) => void;
};

export const LikeTabBar = ({ onTabClick, ...props }: LikeTabBarProps) => {
  const { navigationState } = props;
  const currentRoute = navigationState.routes[navigationState.index];
  const { width: screenWidth } = useScreenSize();
  const tabWidth = screenWidth / navigationState.routes.length;

  return (
    <Flex alignItems={'center'}>
      <TabBar
        {...props}
        onTabPress={({ route }) => {
          const nextIndex = navigationState.routes.indexOf(route);
          onTabClick?.(nextIndex);
        }}
        style={{
          height: 44,
          backgroundColor: Colors.bg_always_white,
          borderBottomWidth: 1,
          borderBottomColor: Colors.border_tertiary,
          elevation: 0,
          shadowOpacity: 0,
          width: screenWidth,
        }}
        tabStyle={{
          width: tabWidth,
        }}
        scrollEnabled={false}
        renderTabBarItem={tabItemProps => {
          const render = tabItemProps.route.render;
          return (
            <TabBarItem
              {...tabItemProps}
              key={tabItemProps.route.key}
              activeColor={render.selected_color}
              inactiveColor={render.unselected_color}
              label={({ route, focused, color }) => (
                <Typography
                  numberOfLines={1}
                  type={focused ? 'subtitle1.5' : 'body1.5'}
                  rawColor={color}
                >
                  {route.name}
                </Typography>
              )}
            />
          );
        }}
        indicatorStyle={{
          height: 2,
          backgroundColor:
            currentRoute?.render.selected_color ?? Colors.content_primary,
        }}
      />
    </Flex>
  );
};
